import Landing from './components/Landing';

function App() {
  return (
    <div className='App'>
      <section className='w-full px-6 pb-12 antialiased bg-white'>
        <div className='mx-auto max-w-7xl'>
          <nav
            className='relative z-50 h-24 select-none'
            x-data='{ showMenu: false }'
          >
            <div className='container relative flex flex-wrap items-center justify-between h-24 mx-auto overflow-hidden font-medium border-b border-gray-200 md:overflow-visible lg:justify-between sm:px-4 md:px-2'>
              <div className='flex items-center justify-start w-1/3 h-full pr-4'>
                <a href='#_' className='inline-block py-4 md:py-0'>
                  <span className='p-1 text-xl font-black leading-none text-gray-900'>
                    <span>{process.env.REACT_APP_TITLE}</span>
                    <span className='text-gray-500'>.</span>{' '}
                  </span>
                </a>
                <a
                  className='inline-block text-gray-500 text-sm'
                  href='https://www.flaticon.com/free-icons/angry'
                  title='angry icons'
                >
                  Angry icons created by Freepik - Flaticon
                </a>
              </div>
              <div className='top-0 left-0 items-start hidden w-full h-full p-4 text-sm bg-gray-900 bg-opacity-50 md:items-center md:w-3/4 md:absolute lg:text-base md:bg-transparent md:p-0 md:relative md:flex'>
                <div className='flex-col w-full h-auto overflow-hidden bg-white rounded-lg md:bg-transparent md:overflow-visible md:rounded-none md:relative md:flex md:flex-row'>
                  <a
                    href='#_'
                    className='inline-flex items-center block w-auto h-16 px-6 text-xl font-black leading-none text-gray-900 md:hidden'
                  >
                    tails<span className='text-gray-500'>.</span>
                  </a>
                </div>
              </div>
            </div>
          </nav>
          <Landing></Landing>
        </div>
      </section>
    </div>
  );
}

export default App;
